import { ActionIcon, Badge, Box, Button, Checkbox, Divider, Grid, Group, Loader, Menu, Modal, Paper, Progress, Switch, Text, Title, UnstyledButton } from '@mantine/core';
import { showNotification } from '@mantine/notifications';
import moment from 'moment';
import React, { useEffect } from 'react';
import { DragDropContext, Draggable, Droppable } from 'react-beautiful-dnd';
import { FaBars, FaClock, FaPen, FaPlus, FaRoute, FaSearch, FaTimes, FaTrash } from 'react-icons/fa';
import { ActionsRender } from '../components/actions_render';
import InputField, { InputFieldTypes } from '../components/input_field';
import InputLocation from '../components/input_location';
import MapTravel from '../components/map_travel';
import SimpleHeader from '../components/simple_header';
import { useApp } from '../contexts/app.context';
import { GET_ALL_AGENCIES } from '../services/agencies';
import { DELETE_ROUTE, GET_ALL_ROUTES, SAVE_ROUTE, SAVE_ROUTE_SHAPES, SAVE_ROUTE_TRIPS } from '../services/routes';
import { GET_ALL_VEHICLES } from '../services/vehicles';
import { extenseWeekday, groupBy } from '../utility/util';

const routeTypes = [
    { label: "Bonde com cabo suspenso, ônibus elétrico, veículo leve sobre trilhos (VLT). Qualquer VLT ou sistema de transporte de superfície em uma área metropolitana.", value: "0" },
    { label: "Metrô, trem subterrâneo. Qualquer sistema de transporte subterrâneo sobre trilhos dentro de uma área metropolitana.", value: "1" },
    { label: "Via férrea. Usado para itinerários intermunicipais ou de longa distância.", value: "2" },
    { label: "Ônibus. Usado para trajetos de ônibus curtos e de longa distância.", value: "3" },
    { label: "Balsa. Usado para serviço de navegação de curta e longa distância.", value: "4" },
    { label: "Bonde a cabo. Usado para vagões de superfície, em que o cabo passa por baixo do veículo, como o bonde de São Francisco.", value: "5" },
    { label: "Teleférico (por exemplo, gôndola). Transporte a cabo em que cabines, carros, gôndolas ou cadeiras abertas são suspensos por um ou mais cabos.", value: "6" },
    { label: "Funicular. Qualquer sistema de trilho projetado para subir ladeiras.", value: "7" },
    { label: "Ônibus elétrico. Ônibus elétricos que recebem energia de cabos suspensos por postes.", value: "11" },
    { label: "Monotrilho. Sistema ferroviário com um único trilho ou uma barra.", value: "12" },
]

const routePickupTypes = [
    { label: "Embarque com paradas contínuas.", value: "0" },
    { label: "Nenhum embarque com paradas contínuas.", value: "1" },
    { label: "Necessário ligar para a empresa e agendar o embarque com paradas contínuas.", value: "2" },
    { label: "Necessário combinar com o motorista para agendar o embarque com paradas contínuas.", value: "3" },
]

const routeDropOffTypes = [
    { label: "Desembarque com paradas contínuas.", value: "0" },
    { label: "Nenhum desembarque com paradas contínuas.", value: "1" },
    { label: "Necessário ligar para a empresa e agendar o desembarque com paradas contínuas.", value: "2" },
    { label: "Necessário combinar com o motorista para agendar o desembarque com paradas contínuas.", value: "3" },
]

export default function RoutesPage(){
    const [items, setItems] = React.useState<any[]>([]);
    const [modal, setModal] = React.useState<any>(null);
    const [search, setSearch] = React.useState<string>("");
    const [modalShapes, setModalShapes] = React.useState<any>(null);
    const [modalTrips, setModalTrips] = React.useState<any>(null);
    const [loadingItems, setLoadingItems] = React.useState<boolean>(false);
    const [loadingDelete, setLoadingDelete] = React.useState({});

    const app = useApp();

    const loadItems = () => {
        setLoadingItems(true)
        GET_ALL_ROUTES()
        .then(res => {
            setItems(res);
            setLoadingItems(false)
        })
        .catch(err => {
            setLoadingItems(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const deleteItem = (routeId) => {
        setLoadingDelete(ld => ({...ld, [`${routeId}`]: true}))
        DELETE_ROUTE(routeId)
        .then(res => {
            setLoadingDelete(ld => ({...ld, [`${routeId}`]: false}))
            loadItems()
        })
        .catch(err => {
            setLoadingDelete(ld => ({...ld, [`${routeId}`]: false}))
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(loadItems, []);

    return <>
        <SimpleHeader
            title="Itinerários"
            right={
                <Group align="flex-end">
                    <InputField
                        name="search"
                        value={search}
                        onChange={({search}) => setSearch(search)}
                        placeholder='Pesquisar itinerário'
                        icon={<FaSearch />}
                    />
                    <Button
                        variant='outline'
                        leftIcon={<FaPlus />}
                        onClick={() => { setModal(true)}}
                    >Adicionar Itinerário</Button>
                </Group>
            }
        />
        <Grid>
            {items
                .filter(i => !search || `${i.route_short_name} ${i.route_long_name}`.toLocaleLowerCase().includes(search.toLocaleLowerCase()))
                .map((item, i) => {
                    // const groupedTravels = groupBy(item.travels, (travel: any) => {
                    //     const status = travel.status.sort((a,b) => a.datetime > b.datetime ? -1 : 1)[0]?.status;
                    //     return {
                    //         '1': "Em andamento",
                    //         '-1': "Canceladas",
                    //         '2': "Finalizadas",
                    //     }[`${status}`] || "Agendadas"
                    // })
                    return (
                        <Grid.Col xs={12} md={4}>
                            <Paper shadow='xs' p="md">
                                <Group align='flex-start'>
                                    <div style={{flex: 1}}>
                                        <Badge>{item.route_short_name}</Badge>
                                        <Title align='center' p="4px" weight="normal" order={5}>{item.route_long_name}</Title>
                                    </div>
                                    <ActionsRender
                                        item={item}
                                        index={item}
                                        actions={[
                                            {
                                                title: "Rota de Ida",
                                                leftIcon: <FaRoute />,
                                                onClick: ({item}) => { setModalShapes({...item, direction: 0}); }
                                            },
                                            {
                                                title: "Rota de Volta",
                                                leftIcon: <FaRoute />,
                                                onClick: ({item}) => { setModalShapes({...item, direction: 1}); }
                                            },
                                            {
                                                title: "Rotinas",
                                                leftIcon: <FaClock />,
                                                onClick: ({item}) => { setModalTrips(item); }
                                            },
                                            {
                                                title: "Editar",
                                                color: "gray",
                                                leftIcon: <FaPen />,
                                                onClick: ({item}) => { setModal(item); }
                                            },
                                            {
                                                title: "Deletar",
                                                color: "red",
                                                leftIcon: <FaTrash />,
                                                loading: item => Boolean(loadingDelete[item._id]), 
                                                onClick: ({item}) => {
                                                    app.confirmDialog(
                                                        {text: "Realmente deseja deletar?"},
                                                        (({confirmed}) => {
                                                            if(confirmed) deleteItem(item._id);
                                                        })
                                                    )
                                                }
                                            },
                                        ]}
                                    />
                                </Group>
                                <Divider mt="xs" mb="xs" />

                                <UnstyledButton style={{width: '100%'}} onClick={() => setModalTrips(item)}>
                                    <Text size="sm" color="orange">{(item.trips || []).length} rotina(s) / {(item.trips || []).reduce((pv, t) => pv.concat(t.intervals), []).length} intervalo(s)</Text>
                                </UnstyledButton>
                                
                                {/* <Divider mt="xs" mb="xs" /> */}
                                {/* <Text size="sm" color="orange">{(item.travels || []).length} Itinerários no Mês</Text>
                                <Progress
                                    size="xl"
                                    sections={[
                                        {
                                            label: "Canceladas",
                                            value: item.travels.length === 0
                                                ? 0
                                                : ((groupedTravels.find(g => g[0] === "Canceladas") || [])[1] || []).length / (item.travels.length/100),
                                            tooltip: `${((groupedTravels.find(g => g[0] === "Canceladas") || [])[1] || []).length} - Canceladas`,
                                            color: 'red',
                                        },
                                        {
                                            label: "Agendadas",
                                            value: item.travels.length === 0
                                                ? 0
                                                : ((groupedTravels.find(g => g[0] === "Agendadas") || [])[1] || []).length / (item.travels.length/100),
                                            tooltip: `${((groupedTravels.find(g => g[0] === "Agendadas") || [])[1] || []).length} - Agendadas`,
                                            color: 'blue',
                                        },
                                        {
                                            label: "Em andamento", 
                                            value: item.travels.length === 0
                                                ? 0
                                                : ((groupedTravels.find(g => g[0] === "Em andamento") || [])[1] || []).length / (item.travels.length/100),
                                            tooltip: `${((groupedTravels.find(g => g[0] === "Em andamento") || [])[1] || []).length} - Em andamento`,
                                            color: 'yellow',
                                        },
                                        {
                                            label: "Finalizadas",
                                            value: item.travels.length === 0
                                                ? 0
                                                : ((groupedTravels.find(g => g[0] === "Finalizadas") || [])[1] || []).length / (item.travels.length/100),
                                            tooltip: `${((groupedTravels.find(g => g[0] === "Finalizadas") || [])[1] || []).length} - Finalizadas`,
                                            color: 'green',
                                        },
                                    ]}
                                /> */}

                                <Divider mt="xs" mb="xs" />
                                
                                <Group position='right'>
                                    {/* <Button onClick={() => navigate(`/dispositivos/${item._id}/historico`)} color="gray" variant='light'>Histórico</Button> */}
                                    {/* <Button variant='light'>Atribuir veículo</Button> */}
                                </Group>
                            </Paper>
                        </Grid.Col>
                    )
                }
            )}
        </Grid>

        <RouteModal
            data={modal}
            opened={!!modal}
            onClose={() => setModal(null)}
            onSave={() => { loadItems(); setModal(null) }}
        />

        <RouteShape
            data={modalShapes}
            opened={!!modalShapes}
            onClose={() => setModalShapes(null)}
            onSave={() => { loadItems(); setModalShapes(null) }}
        />
        
        <RouteTrips
            data={modalTrips}
            opened={!!modalTrips}
            onClose={() => setModalTrips(null)}
            onSave={() => { loadItems(); setModalTrips(null) }}
        />
    </>
}

const RouteShape = (props) => {
    const { data : dataParent = null, onClose, onSave, opened = false } = props;

    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [estimateAutomatic, setEstimateAutomatic] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any[]>([]);
    // const [dataDirections, setDataDirections] = React.useState<any[]>([]);
    const [directions, setDirections] = React.useState<any>(null);
    const [changedDirections, setChangedDirections] = React.useState<any>({});
    const [simulationStart, setSimulationStart] = React.useState<string>("06:00");
    const [simulation, setSimulation] = React.useState<string[]>([]);
    const [editingWaypoint, setEditingWaypoint] = React.useState(null);

    const origin = data[0]
        ? { lat: data[0].shape_pt_lat, lng: data[0].shape_pt_lon, color: data[0].stop ? "00FF00" : "0000FF" }
        : null
    const destination = data.slice(1)[data.length - 2]
        ? { lat: data.slice(1)[data.length - 2].shape_pt_lat, lng: data.slice(1)[data.length - 2].shape_pt_lon, color: data.slice(1)[data.length - 2].stop ? "00FF00" : "0000FF" }
        : null;
    const waypoints = data.slice(1, data.length - 1).map(item => ({ lat: item.shape_pt_lat, lng: item.shape_pt_lon, color: item.stop ? "00FF00" : "0000FF"}))

    const handleSave = () => {
        let dds = [];
        data.forEach((dd, i) => {
            dds.push({
                ...dd,
                title: changedDirections[i]?.title || dd.title,
                estimate: changedDirections[i]?.estimate || dd.estimate,
            })
        })

        setLoadingSave(true)
        SAVE_ROUTE_SHAPES(dataParent?._id, dataParent.direction, dds)
        .then(() => {
            setLoadingSave(false)
            onSave && onSave();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    // const getDirectionDetails = (point) => {
    //     return point?.location
    //     ? { shape_pt_lat: point.location.lat(), shape_pt_lon: point.location.lng() }
    //     : { shape_pt_lat: point.lat(), shape_pt_lon: point.lng() }
    // }

    // const getDataFromDirections = () => {
    //     if(directions){
    //         const others : any[] = [];
    //         if(estimateAutomatic){
    //             (directions?.routes || []).reduce((pv, r) => pv.concat(r.legs), []).forEach((l, i) => {
    //                 others[i] = { ...others[i], title: l.start_address };
    //                 others[i+1] = { ...others[i+1], title: l.end_address, estimate: l.duration.value, distance: l.distance.value };
    //             })
    //         }
    //         return [
    //             directions?.request?.origin ? {...others[0], ...getDirectionDetails(directions?.request?.origin) } : null,
    //             ...(directions?.request?.waypoints || []).map((wp, i) => ({...others[i+1], ...getDirectionDetails(wp.location) })),
    //             directions?.request?.destination ? {...others[others.length - 1], ...getDirectionDetails(directions?.request?.destination) } : null,
    //         ].filter(nn => nn)
    //     }else{
    //         return data;
    //     }
    // }

    const handleDragEnd = (result) => {
        if (!result.destination) return; // Dragged outside the list, ignore
      
        const newData = [...data];
        const [reorderedItem] = newData.splice(result.source.index, 1);
        newData.splice(result.destination.index, 0, reorderedItem);
        
        setData(newData);
    };

    useEffect(() => {
        if(opened){
            const shapes = (dataParent?.shapes || []).filter(s => (
                dataParent.direction === s.direction
            ));
            let cd = [];
            shapes.forEach((s, i) => {
                cd.push({ title: s.title, estimate: s.estimate })
            })
            setData(shapes)
            setChangedDirections(cd)
        }
    }, [opened, dataParent]);
    
    // useEffect(() => {
    //     let vls = [];
    //     let count = 0;
    //     if(moment(`2023-01-01 ${simulationStart}:00`).isValid()){
    //         dataDirections.forEach((d, i) => {
    //             let estimate = ![null, undefined].includes(changedDirections[i]?.estimate) ? changedDirections[i]?.estimate : d.estimate;
    //             count += isNaN(estimate) ? 0 : parseInt(estimate);
    //             vls.push(
    //                 i === 0
    //                 ? simulationStart
    //                 : moment(`2023-01-01 ${simulationStart}:00`).add(count, "seconds").format("HH:mm")
    //             )
    //         })
    //         setSimulation(vls);
    //     }
    // }, [dataDirections, simulationStart, changedDirections])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            fullScreen
        >
            <Grid>
                <Grid.Col xs={12} md={4}>
                    <Paper p="lg" shadow='xs' style={{height: '80vh', overflowY: 'auto'}}>
                        {/* <Group grow>
                            <Switch label="Estimativa e títulos automático" checked={estimateAutomatic} onChange={() => setEstimateAutomatic(a => !a)} />
                            <InputField
                                name="s"
                                onChange={({s}) => setSimulationStart(s)}
                                title={"Simulação Início"}
                                value={simulationStart}
                                fieldType={InputFieldTypes.TIME}
                            />
                        </Group> */}
                        <Divider mt="md" mb="md" />
                        <DragDropContext onDragEnd={handleDragEnd}>
                            <Droppable droppableId="directions">
                                {(provided) => (
                                    <div ref={provided.innerRef} {...provided.droppableProps}>
                                    {data.map((d, i) => {

                                    let title = ![null, undefined].includes(changedDirections[i]?.title) ? changedDirections[i]?.title : d.title;
                                    let estimate = ![null, undefined].includes(changedDirections[i]?.estimate) ? changedDirections[i]?.estimate : d.estimate;
                                    return <Draggable key={i} draggableId={i.toString()} index={i}>
                                        {(provided) => 
                                            !d.stop
                                            ? (
                                                <div
                                                    ref={provided.innerRef}
                                                    {...provided.draggableProps}
                                                    {...provided.dragHandleProps}
                                                >
                                                    <div style={{position: 'relative'}}>
                                                        <div style={{display: 'flex', flexDirection: 'column', alignItems: 'center'}}>
                                                            <div style={{width: 2, height: 20, background: '#4a4a4a'}}></div>
                                                            <div style={{width: 10, height: 10, borderRadius: 10, background: '#0000FF'}}></div>
                                                            <div style={{width: 2, height: 20, background: '#4a4a4a'}}></div>
                                                        </div>
                                                    </div>
                                                </div>
                                                    
                                            )
                                            : (
                                            <div
                                                ref={provided.innerRef}
                                                {...provided.draggableProps}
                                                {...provided.dragHandleProps}
                                            >
                                                <div style={{ borderBottom: '1px solid #E0E0E0', paddingBottom: 20, background: 'white' }}>
                                                    <Group align='flex-start' pt="md" pb="md">
                                                        <InputField
                                                            name="title"
                                                            onChange={({title}) => setChangedDirections(dd => dd.map((item, j) => i === j ? ({...dd[j], title}) : item))}
                                                            title="Título da parada"
                                                            value={title}
                                                            style={{flex: 0.6}}
                                                            />
                                                        <InputField
                                                            name="estimate"
                                                            onChange={({estimate}) => setChangedDirections(dd => dd.map((item, j) => i === j ? ({...dd[j], estimate}) : item))}
                                                            title="Estimativa (segundos)"
                                                            value={i === 0 ? "0" : estimate}
                                                            fieldType={InputFieldTypes.NUMBER}
                                                            style={{ flex: 0.4 }}
                                                            disabled={i === 0}
                                                            helper={i !== 0 ? `${((estimate ? estimate : 0) / 60).toFixed(2)} minutos` : null}
                                                        />
                                                        <FaBars color="#CACACA" />
                                                    </Group>
                                                    <Group position="apart">
                                                        <UnstyledButton onClick={() => {
                                                            setChangedDirections(d => d.filter((it, j) => i !== j));
                                                            setData(d => d.filter((it, j) => i !== j));
                                                        }}><Badge size="sm" color="red">Remover</Badge></UnstyledButton>
                                                        <Badge size="sm" color="yellow">Simulação: {simulation[i]}</Badge>
                                                    </Group>
                                                </div>
                                            </div>
                                        )}
                                        </Draggable>
                                    })}
                                    </div>
                                )}
                            </Droppable>
                        </DragDropContext>
                    </Paper>
                </Grid.Col>
                <Grid.Col xs={12} md={8}>
                    <Paper p="lg" shadow='xs'>
                        <Box mb="lg">
                            <InputLocation
                                label="Pesquisar local"
                                value={null}
                                name="loc"
                                onChange={({loc}) => {
                                    setData(d => [...d, { shape_pt_lat: loc.geometry.location.lat(), shape_pt_lon: loc.geometry.location.lng() }])
                                }}
                            />
                        </Box>
                        <MapTravel
                            googleMapURL="https://maps.googleapis.com/maps/api/js?key=AIzaSyDV8uT7yErfIloYQBp_PXlEyJnTBWJ3Hpk"
                            loadingElement={<Loader />}
                            origin={origin}
                            destination={destination}
                            waypoints={waypoints.map(w => ({ location: w }))}
                            onIconClick={(loc) => {
                                if(loc.right){
                                    setData(d => [
                                        ...d.slice(0, loc.index + 1),
                                        { shape_pt_lat: loc.lat - 0.0002, shape_pt_lon: loc.lng },
                                        ...d.slice(loc.index + 1),
                                    ])
                                }else{
                                    setEditingWaypoint({ index: loc.index, ...data[loc.index] })
                                }
                            }}
                            onPoint={(loc) => {
                                setData(d => 
                                    !isNaN(loc.index)
                                    ? d.map((dd,i) => i === loc.index ? { ...dd, shape_pt_lat: loc.lat, shape_pt_lon: loc.lng } : dd)
                                    : [...d, { shape_pt_lat: loc.lat, shape_pt_lon: loc.lng }]
                                )
                            }}
                            // height={'calc(80vh - 200px)'}
                            onCalculate={setDirections}
                        />
                    </Paper>
                    <Group position='center' mt="xl">
                        <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                        <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
                    </Group>
                </Grid.Col>
            </Grid>

        </Modal>
        <Modal
            opened={!!editingWaypoint}
            onClose={() => setEditingWaypoint(null)}
            closeOnClickOutside
            size="lg"
        >
            <Group grow>
                <Button fullWidth mb="xs" color="red" variant='outline' onClick={() => {
                        setData(d => [
                            ...d.slice(0, editingWaypoint.index),
                            ...d.slice(editingWaypoint.index + 1),
                        ])
                        setEditingWaypoint(null);
                    }}
                >Remover ponto</Button>
                <Button fullWidth mb="xs" color={editingWaypoint?.stop ? "blue" : "green"} variant='outline' onClick={() => {
                        setEditingWaypoint(null);
                        setData(d => {
                            let loc = editingWaypoint
                            return d.map((dd,i) => i === loc.index ? { ...dd, stop: loc.stop ? false : true } : dd)    
                        })
                    }}
                >{editingWaypoint?.stop ? "Transformar em ponto simples" : "Transformar em parada"}</Button>
            </Group>

            <Group mb="xs" align='flex-end'>
                <InputField
                    name="title"
                    title="Título"
                    style={{flex: 1}}
                    value={editingWaypoint?.title}
                    onChange={({title}) => {
                        setEditingWaypoint(e => ({...e, title}))
                    }}
                />
                <InputField
                    name="estimate"
                    title="Estimativa"
                    style={{flex: 1}}
                    value={editingWaypoint?.estimate}
                    onChange={({estimate}) => {
                        setEditingWaypoint(e => ({...e, estimate}))
                    }}
                />
                <Button
                    onClick={() => {
                        setData(d => [
                            ...d.slice(0, editingWaypoint.index),
                            { ...d[editingWaypoint.index], ...editingWaypoint },
                            ...d.slice(editingWaypoint.index + 1),
                        ]);
                        setChangedDirections(d => [
                            ...d.slice(0, editingWaypoint.index),
                            { ...d[editingWaypoint.index], ...editingWaypoint },
                            ...d.slice(editingWaypoint.index + 1),
                        ])
                        setEditingWaypoint(null);
                    }}
                >Aplicar</Button>
            </Group>
        </Modal>
    </>
}

const RouteTrips = (props) => {
    const { data : dataParent = null, onClose, onSave, opened = false } = props;

    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any[]>([]);
    const [vehicles, setVehicles] = React.useState<any[]>([]);

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_ROUTE_TRIPS(dataParent?._id, data)
        .then(() => {
            setLoadingSave(false)
            onSave && onSave();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }
    
    const loadVehicles = () => {
        GET_ALL_VEHICLES()
        .then((res) => {
            setVehicles(res)
        })
        .catch(err => {
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(() => {
        if(opened) setData(dataParent?.trips || [])
    }, [opened, dataParent])
    
    useEffect(() => {
        loadVehicles()
    }, [])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            fullScreen
        >
            {data.map((item, i) => <Paper mb="md" shadow="xs" p="md">
                <Button color="red" variant="subtle" onClick={() => setData(d => d.filter((item2, j) => i !== j))}>Remover</Button>
                <Group position='center' mb="lg">
                    <InputField
                        name="start"
                        title="Data Inicial"
                        value={item.start ? moment(item.start).toDate() : null}
                        fieldType={InputFieldTypes.DATE}
                        onChange={({start}) => setData(d => d.map((item, j) => i === j ? {...item, start} : item))}
                    />
                    <InputField
                        name="finish"
                        title="Data Final"
                        value={item.finish ? moment(item.finish).toDate() : null}
                        fieldType={InputFieldTypes.DATE}
                        onChange={({finish}) => setData(d => d.map((item, j) => i === j ? {...item, finish} : item))}
                    />
                </Group>
                <Group position='center'>
                    {Array(7).fill({}).map((wd, wdi) => 
                        <Button
                            onClick={() => {
                                setData(d => d.map((d, j) => i === j ? {
                                    ...d,
                                    weekdays: (d.weekdays || []).includes(wdi)
                                        ? (item.weekdays || []).filter(it => it !== wdi)
                                        : [...(item.weekdays || []), wdi]
                                } : d))
                            }}
                            variant={(item.weekdays || []).includes(wdi) ? 'filled' : 'outline'}>
                            {extenseWeekday(wdi)}
                        </Button>
                    )}
                </Group>
                <Group mt="lg">
                    <Title order={5}>Agenda de horários</Title>
                    <Button
                        size="xs"
                        onClick={() => {
                            setData(d => d.map((d, j) => i === j ? {
                                ...d, intervals: [...(d.intervals || []), {}]
                            } : d))
                        }}
                        variant="subtle" leftIcon={<FaPlus />}
                    >Adicionar horário</Button>
                </Group>
                <Group mt="lg" position='center'>
                    {(item.intervals || []).map((interval, intervalI) => {
                        return <Paper shadow='xs' m="xs" p="md">
                            <Group position='center' align='flex-start'>
                                <Box>
                                    <Group grow>
                                        <InputField
                                            name="type"
                                            title="Tipo"
                                            value={interval.type}
                                            fieldType={InputFieldTypes.SELECT}
                                            options={[
                                                { label: "Ida", value: "0" },
                                                { label: "Volta", value: "1" },
                                            ]}
                                            onChange={({type}) => setData(d => d.map((item, j) => i === j ? {...item, 
                                                intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ ? {...iv, type} : iv)
                                            } : item))}
                                        />
                                        <InputField
                                            name="time"
                                            title="Horário de Saída"
                                            value={interval.time ? interval.time : null}
                                            fieldType={InputFieldTypes.TIME}
                                            onChange={({time}) => setData(d => d.map((item, j) => i === j ? {...item, 
                                                intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ ? {...iv, time} : iv)
                                            } : item))}
                                        />
                                    </Group>
                                    <Group grow>
                                        <InputField
                                            name="vehicle"
                                            title="Veículo"
                                            value={interval.vehicle ? interval.vehicle : null}
                                            options={vehicles.map(v => ({value: v._id, label: v.license_plate}))}
                                            fieldType={InputFieldTypes.SELECT}
                                            onChange={({vehicle}) => setData(d => d.map((item, j) => i === j ? {...item, 
                                                intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ ? {...iv, vehicle} : iv)
                                            } : item))}
                                        />
                                        <div>
                                            <Text style={{visibility: 'hidden'}}>&nbsp;</Text>
                                            <Menu closeOnItemClick={false} position='top'>
                                                <Menu.Target><Button fullWidth variant='outline'>Exceções ({(interval.exceptions || []).length + (interval.holidays_exception ? 1 : 0)})</Button></Menu.Target>
                                                <Menu.Dropdown>
                                                    <Menu.Item onClick={() => {
                                                        setData(d => d.map((item, j) => i === j ? {...item, 
                                                            intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ ? {...iv, holidays_exception: !iv.holidays_exception} : iv)
                                                        } : item))
                                                    }}>
                                                        <Group>
                                                            <Checkbox checked={interval.holidays_exception} />
                                                            <Text>Feriados</Text>
                                                        </Group>
                                                    </Menu.Item>
                                                    {(interval.exceptions || []).map((exception, exI) => <Menu.Item>
                                                        <Group>
                                                            <InputField
                                                                mb="lg"
                                                                name="period"
                                                                title="Período de exceção"
                                                                fieldType={InputFieldTypes.DATERANGE}
                                                                value={(exception.period || []).map(p => p ? moment(p).toDate() : p)}
                                                                onChange={({period}) => {
                                                                    setData(d => d.map((item, j) => i === j ? {...item, 
                                                                        intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ 
                                                                            ? {...iv, exceptions: iv.exceptions.map((ex, exJ) => exI === exJ ? {...ex, period} : ex)}
                                                                            : iv)
                                                                    } : item))
                                                                }}
                                                            />
                                                            <ActionIcon onClick={() => {
                                                                setData(d => d.map((item, j) => i === j ? {...item, 
                                                                    intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ 
                                                                        ? {...iv, exceptions: iv.exceptions.filter((ex, exJ) => exI !== exJ)}
                                                                        : iv)
                                                                } : item))
                                                            }}><FaTimes /></ActionIcon>
                                                        </Group>
                                                    </Menu.Item>)}
                                                    <Menu.Item color="gray" icon={<FaPlus />} onClick={() => {
                                                        setData(d => d.map((item, j) => i === j ? {...item, 
                                                            intervals: (item.intervals || []).map((iv, intervalJ) => intervalI === intervalJ 
                                                                ? {...iv, exceptions: [...(iv.exceptions || []), {period: [moment().format("YYYY-MM-DD"), moment().format("YYYY-MM-DD")]}]}
                                                                : iv)
                                                        } : item))
                                                    }}>Adicionar</Menu.Item>
                                                </Menu.Dropdown>
                                            </Menu>
                                        </div>
                                    </Group>
                                </Box>
                                <ActionIcon onClick={() => setData(d => d.map((item, j) => i === j ? {...item, intervals: (item.intervals || []).filter((iv, intervalJ) => intervalI !== intervalJ)} : item))}><FaTimes /></ActionIcon>
                            </Group>
                        </Paper>
                    })}
                </Group>
            </Paper>)}

            <Group position="right" mt="xs">
                <Button size="xs" onClick={() => setData(d => [...d, { weekdays: [], intervals: [], start: moment().startOf("year").format(), finish: moment().endOf("year").format() }])} variant="subtle" leftIcon={<FaPlus />}>Adicionar Rotina</Button>
            </Group>
            <Group position='right' mt="xl">
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>

    </>
}

const RouteModal = (props) => {
    const { data : dataParent = null, onClose, onSave, opened = false } = props;
    const [loadingSave, setLoadingSave] = React.useState<boolean>(false);
    const [data, setData] = React.useState<any>(null);
    const [agencies, setAgencies] = React.useState<any[]>([]);

    const handleChange = dt => setData(d => ({...d, ...dt}));

    const handleSave = () => {
        setLoadingSave(true)
        SAVE_ROUTE({ ...data, id: dataParent?._id })
        .then(() => {
            setLoadingSave(false)
            onSave && onSave();
        })
        .catch(err => {
            setLoadingSave(false)
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    const loadAgencies = () => {
        GET_ALL_AGENCIES()
        .then(res => {
            setAgencies(res);
        })
        .catch(err => {
            showNotification({title: "Ops", message: err.message, color: 'red'})
        })
    }

    useEffect(() => {
        loadAgencies()
        if(opened) setData({...dataParent})
    }, [opened, dataParent])

    return <>
        <Modal
            opened={!!opened}
            onClose={onClose}
            size="lg"
        >
            {/* <InputField
                mb="lg"
                name="agency"
                title="Agência *"
                fieldType={InputFieldTypes.SELECT}
                options={agencies.map(a => ({value: a._id, label: a.agency_name}))}
                value={data?.agency}
                onChange={handleChange}
            /> */}
            <InputField
                mb="lg"
                name="route_short_name"
                title="Título curto *"
                value={data?.route_short_name}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="route_long_name"
                title="Título longo *"
                value={data?.route_long_name}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="route_type"
                title="Tipo do trajeto *"
                fieldType={InputFieldTypes.SELECT}
                options={routeTypes}
                value={data?.route_type}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="going_name"
                title="Título de ida"
                value={data?.going_name}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="returning_name"
                title="Título de volta"
                value={data?.returning_name}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="route_desc"
                title="Descrição"
                fieldType={InputFieldTypes.TEXTAREA}
                value={data?.route_desc}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="route_url"
                title="Link do trajeto"
                value={data?.route_url}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="route_color"
                title="Cor do trajeto"
                fieldType={InputFieldTypes.COLOR}
                value={data?.route_color}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="route_text_color"
                title="Cor dos textos"
                fieldType={InputFieldTypes.COLOR}
                value={data?.route_text_color}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="continuous_pickup"
                title="Tipo do embarque"
                fieldType={InputFieldTypes.SELECT}
                options={routePickupTypes}
                value={data?.continuous_pickup}
                onChange={handleChange}
            />
            <InputField
                mb="lg"
                name="continuous_drop_off"
                title="Tipo do desembarque"
                fieldType={InputFieldTypes.SELECT}
                options={routeDropOffTypes}
                value={data?.continuous_drop_off}
                onChange={handleChange}
            />

            <Group position='right'>
                <Button variant='subtle' disabled={loadingSave} onClick={onClose}>Cancelar</Button>
                <Button variant='filled' loading={loadingSave} onClick={handleSave}>Salvar</Button>
            </Group>
        </Modal>
    </>
}